import { styled } from '@mui/system';
import { FC, useEffect, useState } from 'react';
import { useIcon } from '../../Hooks/useIcon';

interface LinkBlockProps {
  padding: number;
  iconBackground: string;
  iconColor: string;
  textColor: string;
  bgColor: string;
  titleType?: string;
  blockPosition?: string;
  hideIcon?: boolean;
  icon: string;
  title: string;
  documentLink?: string;
  openInNewWindow?: boolean;
}

const RootDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  margin: '5px 0',

  '& .link-block-outer-bg': {
    borderRadius: '12px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    border: '2px solid #bbb',
    minWidth: 195,
    margin: '0 10px',
  },
  '& .title-icon': {
    fontSize: '32px',
    padding: '10px 10px 5px',
    borderRadius: '50%',
  },
  '& .title-text': {
    fontSize: '16px',
    fontWeight: 200,
    marginTop: 5,
  },
});

const LinkBlock: FC<LinkBlockProps> = ({
  padding,
  iconBackground,
  iconColor = '#222',
  textColor = '#222',
  bgColor = 'transparent',
  blockPosition = 'center',
  hideIcon = false,
  icon,
  title,
  documentLink,
  openInNewWindow = false,
}) => {
  const [Style, setStyle] = useState<any>({
    padding,
    iconBackground,
    iconColor,
    bgColor,
    textColor,
    titleType: 'document',
  });

  useEffect(() => {
    setStyle({
      padding,
      iconBackground,
      iconColor,
      bgColor,
      textColor,
    });
  }, [padding, iconBackground, iconColor, bgColor, textColor]);

  return (
    <RootDiv style={{ justifyContent: blockPosition }}>
      <div
        data-href={documentLink}
        data-new-window={openInNewWindow ? 'true' : 'false'}
        className="link-block-outer-bg"
        style={{ backgroundColor: bgColor, padding: Style.padding }}
      >
        {!hideIcon && (
          <div
            className="title-icon"
            style={{ backgroundColor: iconBackground }}
          >
            <TitleIcon color={Style.iconColor} iconName={icon} />
          </div>
        )}
        <div
          className="title-text"
          style={{
            color: Style.textColor,
            paddingTop: hideIcon ? 10 : 0,
          }}
        >
          {title}
        </div>
      </div>
    </RootDiv>
  );
};

export default LinkBlock;

interface TitleIconProps {
  color: string;
  iconName: string;
}

const TitleIcon: FC<TitleIconProps> = ({ color, iconName }) => {
  const Icon = useIcon({ color, iconName });
  return <>{Icon}</>;
};
